/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Originating channel of a lead. Sent by external and internal callers via the CHANNEL request header. Defaults to LMS when not supplied.
 */
export type Channel = typeof Channel[keyof typeof Channel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Channel = {
  ONLINE_CONTACT_FORM: 'ONLINE_CONTACT_FORM',
  ONLINE_APPLICATION_FORM: 'ONLINE_APPLICATION_FORM',
  WHATSAPP: 'WHATSAPP',
  FACEBOOK: 'FACEBOOK',
  LMS: 'LMS',
  WEBSITE: 'WEBSITE',
  PHONE: 'PHONE',
  CAMPAIGN: 'CAMPAIGN',
} as const;
